import actions from 'actions/orders/orderItems'
import locationActions from 'actions/locations'
import supplierActions from 'actions/suppliers'
import assetActions from 'actions/assets'
import jobActions from 'actions/jobs'
import operatorActions from 'actions/operators'
import tagListActions from 'actions/tagLists'
import { createChildFormViewContainer } from 'factories/ChildFormView'
import { createChildItemsDispatchToProps } from 'helpers/formViews'
import supplierDetailActions from 'actions/products/supplierDetails'
import productActions from 'actions/products'
import Component from 'components/Issue/Items/FormView'

export default createChildFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    getLocations: (params) =>
      dispatch(locationActions.getItems({ ...params, locationVendingTypes: ['NonVending'] })),
    getJob: (jobId) => dispatch(jobActions.getItem(jobId)),
    getOperator: (operatorId) => dispatch(operatorActions.getItem(operatorId)),
    getAsset: (assetId) => dispatch(assetActions.getItem(assetId)),
    getSuppliers: (params) =>
      dispatch(
        supplierActions.getOptions({
          pageIndex: 1,
          pageSize: 100,
          ...params,
          active: 'Active',
        })
      ),
    getAssets: (params) =>
      dispatch(
        assetActions.getOptions({
          pageIndex: 1,
          pageSize: 100,
          ...params,
        })
      ),
    getJobs: (params) =>
      dispatch(
        jobActions.getOptions({
          pageIndex: 1,
          pageSize: 100,
          ...params,
        })
      ),
    getOperators: (params) =>
      dispatch(
        operatorActions.getOptions({
          pageIndex: 1,
          pageSize: 100,
          ...params,
          active: 'Active',
        })
      ),
    getTagListItems: (params) => dispatch(tagListActions.getOptions(params)),
    findByBarcode: (params) => dispatch(productActions.findByBarcode(params)),
    ...createChildItemsDispatchToProps(dispatch, 'SupplierDetail', supplierDetailActions),
  }),
})(Component)
